<section class="footer">
  <div class="footer__menu">
    <div class="footer__logo">
      <mflooring-logo-footer [content]="logoContent" [presentation]="logoPresentation">
      </mflooring-logo-footer>
    </div>
    @for (item of menu?.siteMenuItems; track trackBy(i, item); let i = $index) {
      <nav class="footer__menu__item" [attr.aria-label]="item.name"
        >
        <p class="footer__menu__title">{{ item.name }}</p>
        @if (!!item.childMenuItems.length) {
          <ul class="footer__menu__list" role="menu">
            @for (
              subitem of item?.childMenuItems; track trackBy(j,
              subitem); let j = $index) {
              <li role="menuitem">
                <mflooring-menu-item id="subMenuItem-{{ i }}-{{ j }}" [site]="subitem?.links?.site" [page]="page"
                  [hasChildren]="subitem.childMenuItems.length">
                  <div class="link-section">
                    {{ subitem.name }}
                    @if (checkUrlIsExternal(subitem?.links?.site?.href)) {
                      <img src="/assets/images/link_white.png" alt=""
                        loading="lazy" decoding="async"
                        />
                    }
                  </div>
                </mflooring-menu-item>
              </li>
            }
          </ul>
        }
      </nav>
    }
    <div class="footer__menu__search-box">
      <h3>
        SUBSCRIBE TO OUR EMAIL
      </h3>
      <!-- Custom Hubspot Form -->
      <mflooring-custom-hubspot-form
        [portalId]="hubspotData?.['mf.hubspot.portalId']"
        [formId]="hubspotData?.['mf.hubspot.footer.formId']"
      ></mflooring-custom-hubspot-form>
    </div>
  </div>
</section>